<div class="modal fade in" id="remove-from-group-dialog" role="dialog" style="display: none;" appDraggable dragTarget="#remove-from-group-dialog" dragHandle="#removeFromGroupDialogHeader">
	<div class="modal-dialog modal-sm">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header" id="removeFromGroupDialogHeader">
				<button type="button" class="close" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i></button>
				<h4 class="modal-title">Delete From Group</h4>
			</div>
			<div class="modal-body">
				<p>Delete the following items from which group?</p>
				<div id="deleteGroupDropDown">
					<select style="color: #000000" [(ngModel)]="mSelectedGroup" >
						<ng-container *ngIf="mGroups != null">
							<option *ngFor="let group of mGroups" [ngValue]="group">
								{{group.name}}
							</option>
						</ng-container>
					</select>
				</div>
				<div id="deleteFromGroupName">
					<ng-container *ngIf="mItemNames != null">
						<ng-container *ngFor="let itemName of mItemNames">
							<div>{{itemName}}</div>
						</ng-container>
					</ng-container>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>
				<button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
			</div>
		</div>
	</div>
</div>